<template>
<div>
  <CRow class="pt-4">
      <CCol>
        <CCard>
          <CCardBody>
            <CTabs @update:activeTab="updateActiveTab" :activeTab="activeTab">
              <CTab title="Recent offers">
                <Offered sort="DATE" />  
              </CTab>
              <CTab title="Recent sales">
                <Sold v-if="isLoggedIn" />
                <div v-else>
                  <p class="mt-4 ml-4">
                    Please <b><CLink to="/login">Sign In</CLink></b> or <b><CLink to="/register">Register</CLink></b> to see recent sales.
                  </p> 
                </div>
              </CTab>
              <CTab title="Grain wanted">
                <template slot="title">
                  Grain wanted <CBadge color="success" class="ml-1" style="position: relative; top: -2px;">New</CBadge>
                </template>
                <GrainWanted/>  
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>
      </CCol>
  </CRow>
</div>
</template>

<script>
import Offered from './Offered'
import Sold from './Sold'
import GrainWanted from '@/views/wanted/GrainWanted'

export default {
  name: 'OfferedSold',
  components: {
    Offered,
    Sold,
    GrainWanted
  },
  data () {
    return {
      activeTab: 0
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters['auth/isLoggedIn']
    }
  },
  methods: {
    updateActiveTab (tab) {
      this.activeTab = tab
    },
  }
}
</script>

